import MainLayout from '@/layout/MainLayout.vue'
import TemplateRoutingDocumentList from '@/pages/administration/template-routing/documents/TemplateRoutingDocumentList.vue'
import RoleList from '@/pages/administration/roles/RoleList.vue'
import RoleSingle from '@/pages/administration/roles/single/RoleSingle.vue'
import InternalDepartmentList from '@/pages/administration/org-structure/internal/InternalDepartmentList.vue'
import InternalStaffUnitIndex from '@/pages/administration/org-structure/internal/internal-staff-unit/Index.vue'
import EmployeeList from '@/pages/administration/org-structure/internal/EmployeeList.vue'
import OrgDepartmentTypeList from '@/pages/administration/org-structure/directories/OrgDepartmentTypeList.vue'
import OrgPositionList from '@/pages/administration/org-structure/directories/OrgPositionList.vue'
import OrgStaffUnitTypeList from '@/pages/administration/org-structure/directories/OrgStaffUnitTypeList.vue'
import OrgAppointmentTypeList from '@/pages/administration/org-structure/directories/OrgAppointmentTypeList.vue'
import DocTypeClassList from '@/pages/administration/doc-types/DocTypeClassList.vue'
import FieldDefinitionList from '@/pages/administration/doc-types/FieldDefinitionList.vue'
import DocTypeDefinitionList from '@/pages/administration/doc-types/definition/DocTypeDefinitionList.vue'
import DocTypeDefinitionSingle from '@/pages/administration/doc-types/definition/single/DocTypeSingle.vue'
import DocTypeDefinitionGeneralInfo from '@/pages/administration/doc-types/definition/single/tabs/GeneralInfo.vue'
import DocTypeDefinitionFields from '@/pages/administration/doc-types/definition/single/tabs/Fields.vue'
import DocTypeDefinitionRoutes from '@/pages/administration/doc-types/definition/single/tabs/routes/Routes.vue'
import DocTypeActions from '@/pages/administration/doc-types/definition/single/tabs/Actions.vue'
import DocTypeDefinitionAccesses from '@/pages/administration/doc-types/definition/single/tabs/accesses/Accesses.vue'
import OrganizationList from '@/pages/administration/organizations/OrganizationList.vue'
import RegistrationJournalList from '@/pages/administration/registration-journals/RegistrationJournalList.vue'
import RegistrationJournalSingle from '@/pages/administration/registration-journals/single/RegistrationJournalSingle.vue'
import RegistrationJournalGeneralInfo from '@/pages/administration/registration-journals/single/tabs/GeneralInfo.vue'
import RegistrationJournalDefinitions from '@/pages/administration/registration-journals/single/tabs/Definitions.vue'
import RegistrationJournalDepartments from '@/pages/administration/registration-journals/single/tabs/Departments.vue'
import RegistrationJournalAccesses from '@/pages/administration/registration-journals/single/tabs/Accesses.vue'
import InternalStaffUnitSingle from '@/pages/administration/org-structure/internal/internal-staff-unit/single/InternalStaffUnitSingle.vue'

export default [
  {
    name: 'administration',
    path: '/administration',
    component: MainLayout,
    meta: {
      title: 'Адміністрування',
    },
    children: [
      {
        path: '/template-routing-document',
        name: 'template-routing-document',
        component: TemplateRoutingDocumentList,
        meta: {
          title: 'Маршрутизація документів',
          resource: 'document-templates',
        },
      },
      {
        path: '/roles',
        name: 'role-list',
        component: RoleList,
        meta: {
          title: 'Ролі та права',
          resource: 'roles',
        },
      },
      {
        path: '/roles/:id',
        name: 'role-single',
        component: RoleSingle,
        meta: {
          title: 'Роль',
          resource: 'roles',
        },
      },
      {
        path: '/org-internal-departments',
        name: 'org-internal-departments',
        component: InternalDepartmentList,
        meta: {
          title: 'Внутрішні підрозділи',
          resource: 'internal-departments',
        },
      },
      {
        path: '/org-internal-staff-units',
        name: 'org-internal-staff-units',
        component: InternalStaffUnitIndex,
        meta: {
          title: 'Внутрішні штатні одиниці',
          resource: 'internal-staff-units',
        },
        children: [
          {
            path: ':id',
            name: 'internal-staff-unit-single',
            component: InternalStaffUnitSingle,
            meta: {
              title: 'Підрозділ',
            },
          },
        ],
      },
      {
        path: '/org-internal-employees',
        name: 'org-internal-employees',
        component: EmployeeList,
        meta: {
          title: 'Співробітники внутрішніх підрозділів',
          resource: 'users',
        },
      },
      {
        path: '/org-department-types',
        name: 'org-department-types',
        component: OrgDepartmentTypeList,
        meta: {
          title: 'Довідник підрозділів',
          resource: 'org-department-types',
        },
      },
      {
        path: '/org-positions',
        name: 'org-positions',
        component: OrgPositionList,
        meta: {
          title: 'Довідник посад',
          resource: 'org-positions',
        },
      },
      {
        path: '/org-staff-unit-types',
        name: 'org-staff-unit-types',
        component: OrgStaffUnitTypeList,
        meta: {
          title: 'Довідник типів штатних одиниць',
          resource: 'org-staff-unit-types',
        },
      },
      {
        path: '/org-appointment-types',
        name: 'org-appointment-types',
        component: OrgAppointmentTypeList,
        meta: {
          title: 'Довідник типів призначення',
          resource: 'org-appointment-types',
        },
      },
      {
        path: '/doc-type-classes',
        name: 'doc-type-classes',
        component: DocTypeClassList,
        meta: {
          title: 'Класи документів',
          resource: 'doc-types',
        },
      },
      {
        path: '/doc-type-definitions',
        name: 'doc-type-definitions',
        component: DocTypeDefinitionList,
        meta: {
          title: 'Довідник типів документів',
          resource: 'doc-types',
        },
      },
      {
        path: '/doc-type-definition/:id',
        name: 'doc-type-definition-single',
        component: DocTypeDefinitionSingle,
        redirect: { name: 'doc-type-definition-general-info' },
        meta: {
          title: 'Тип документа',
          resource: 'doc-types',
          tabList: true,
        },
        children: [
          {
            path: 'general-info',
            name: 'doc-type-definition-general-info',
            component: DocTypeDefinitionGeneralInfo,
            meta: {
              title: 'Основне',
            },
          },
          {
            path: 'fields',
            name: 'doc-type-definition-fields',
            component: DocTypeDefinitionFields,
            meta: {
              title: 'Конструктор',
            },
          },
          {
            path: 'routes',
            name: 'doc-type-definition-routes',
            component: DocTypeDefinitionRoutes,
            meta: {
              title: 'Маршрути',
            },
          },
          {
            path: 'actions',
            name: 'doc-type-definition-actions',
            component: DocTypeActions,
            meta: {
              title: 'Дії',
            },
          },
          {
            path: 'accesses',
            name: 'doc-type-definition-accesses',
            component: DocTypeDefinitionAccesses,
            meta: {
              title: 'Доступи',
            },
          },
        ],
      },
      {
        path: '/field-definitions',
        name: 'field-definitions',
        component: FieldDefinitionList,
        meta: {
          title: 'Бібліотека полів',
          resource: 'doc-types',
        },
      },
      {
        path: '/registration-journals',
        name: 'registration-journals',
        component: RegistrationJournalList,
        meta: {
          title: 'Журнали реєстрацій',
          resource: 'doc-types',
        },
      },
      {
        path: '/registration-journal/:id',
        name: 'registration-journal-single',
        component: RegistrationJournalSingle,
        redirect: { name: 'registration-journal-general-info' },
        meta: {
          title: 'Журнал реєстрацій',
          tabList: true,
        },
        children: [
          {
            path: 'general-info',
            name: 'registration-journal-general-info',
            component: RegistrationJournalGeneralInfo,
            meta: {
              title: 'Загальні дані',
            },
          },
          {
            path: 'definitions',
            name: 'registration-journal-definitions',
            component: RegistrationJournalDefinitions,
            meta: {
              title: 'Типи документів',
            },
          },
          {
            path: 'departments',
            name: 'registration-journal-departments',
            component: RegistrationJournalDepartments,
            meta: {
              title: 'Підрозділи',
            },
          },
          {
            path: 'accesses',
            name: 'registration-journal-accesses',
            component: RegistrationJournalAccesses,
            meta: {
              title: 'Доступи',
            },
          },
        ],
      },
      {
        path: '/organizations',
        name: 'organizations',
        component: OrganizationList,
        meta: {
          title: 'Організації',
          resource: 'organizations',
        },
      },
    ],
  },
]
